/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import { CTAContentfulForHero } from 'bundles/coursera-plus-landing-page/components/ctaContentful/CTAContentful';
import CourseraLiteLogo from 'bundles/coursera-plus-landing-page/components/heroContentful/CourseraLiteLogo';
import CourseraPlusLogo from 'bundles/coursera-plus-landing-page/components/heroContentful/CourseraPlusLogo';
import type { StaticComponentProps } from 'bundles/coursera-plus-landing-page/components/heroContentful/Hero';
import HeroText from 'bundles/coursera-plus-landing-page/components/heroContentful/HeroText';

const styles = {
  container: () => css`
    max-width: 1200px;
    margin: 20px auto;
    padding: 20px;
  `,
};

const HeroDesignWithNoImage = (props: StaticComponentProps) => {
  return (
    <Grid container direction="row" css={styles.container}>
      <Grid item sm={12} md={11} direction="column">
        {props.isCourseraLiteContentfulPage ? <CourseraLiteLogo /> : <CourseraPlusLogo />}
        <HeroText />
        <CTAContentfulForHero />
      </Grid>
    </Grid>
  );
};

export default HeroDesignWithNoImage;
